/* eslint-disable require-yield */
/* eslint-disable no-useless-catch */
/* eslint-disable no-undef */
// userSaga.js
import { call, put, takeEvery } from 'redux-saga/effects';
import { APPOINTMENT_REQUEST_PAST, APPOINTMENT_REQUEST_TODAY, APPOINTMENT_REQUEST_UPCOMING } from './Constant';
import axios from 'axios';
import { Modal } from 'antd';
import { pastAppointmentsRequestError, pastAppointmentsRequestSuccess, todayAppointmentsRequestError, todayAppointmentsRequestSuccess, upComingAppointmentsRequestError, upComingAppointmentsRequestSuccess } from './Actions';


function* TodayAppointments(action) {

    try {    

        let pageNo = action.page;
        if (pageNo == null) {
            pageNo = 1;
        }
        const skip = (pageNo - 1) * 4;
        
        const patientId = localStorage.getItem('PATIENT_IDS');
        const url = `${process.env.REACT_APP_API_BASE_URL}/myappointments?mode=present&patientsId=${patientId}&limit=4&skip=${skip}&organisationsId=140`;
  
        // // Example headers - You can add more headers as per your requirement
        const headers = {
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            'Content-Type': 'application/json',
            Authorization: sessionStorage.jwt,
            limit: 1000,
            skip: 0,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };        
  
        const response = yield call(axios.get, url,{ headers});

        // Check if the response is successful
        if (response.status === 200 || response.status === 201) {
            yield put(todayAppointmentsRequestSuccess(response.data));
        } 
        else if (response.status === 204) {
            Modal.warning({
                title: 'No Appointments found',
            });
            
            yield put(todayAppointmentsRequestSuccess());
        }else {
            // Dispatch the failure action with the response message
            yield put(todayAppointmentsRequestError());
        }

    } catch (error) {
        // yield put(patientDetailsRequestError('An error occurred.'));
        throw error;
    // yield put(fetchUserFailure(error));
    }
}

function* UpComingAppointments(action) {

    try {    

        let pageNo = action.page;
        if (pageNo == null) {
            pageNo = 1;
        }
        const skip = (pageNo - 1) * 4;
        
        const patientId = localStorage.getItem('PATIENT_IDS');
        const url = `${process.env.REACT_APP_API_BASE_URL}/myappointments?mode=future&patientsId=${patientId}&limit=4&skip=${skip}&organisationsId=140`;
  
        // // Example headers - You can add more headers as per your requirement
        const headers = {
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            'Content-Type': 'application/json',
            Authorization: sessionStorage.jwt,
            limit: 1000,
            skip: 0,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };        
  
        const response = yield call(axios.get, url,{ headers});

        // Check if the response is successful
        if (response.status === 200 || response.status === 201) {
            yield put(upComingAppointmentsRequestSuccess(response.data));
        } 
        else if (response.status === 204) {
            Modal.warning({
                title: 'No Appointments found',
            });
            
            yield put(upComingAppointmentsRequestSuccess());
        }else {
            // Dispatch the failure action with the response message
            yield put(upComingAppointmentsRequestError());
        }

    } catch (error) {
        // yield put(patientDetailsRequestError('An error occurred.'));
        throw error;
    // yield put(fetchUserFailure(error));
    }
}

function* PastAppointments(action) {

    try {    

        let pageNo = action.page;
        if (pageNo == null) {
            pageNo = 1;
        }
        const skip = (pageNo - 1) * 4;
        
        const patientId = localStorage.getItem('PATIENT_IDS');
        const url = `${process.env.REACT_APP_API_BASE_URL}/myappointments?mode=past&patientsId=${patientId}&limit=4&skip=${skip}&organisationsId=140`;
  
        // // Example headers - You can add more headers as per your requirement
        const headers = {
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            'Content-Type': 'application/json',
            Authorization: sessionStorage.jwt,
            limit: 1000,
            skip: 0,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };        
  
        const response = yield call(axios.get, url,{ headers});

        // Check if the response is successful
        if (response.status === 200 || response.status === 201) {
            yield put(pastAppointmentsRequestSuccess(response.data));
        } 
        else if (response.status === 204) {
            Modal.warning({
                title: 'No Appointments found',
            });
            
            yield put(pastAppointmentsRequestSuccess());
        }else {
            // Dispatch the failure action with the response message
            yield put(pastAppointmentsRequestError());
        }

    } catch (error) {
        // yield put(patientDetailsRequestError('An error occurred.'));
        throw error;
    // yield put(fetchUserFailure(error));
    }
}


// Watcher Saga
export function* watchFetchAppointmentsList() {
    yield takeEvery(APPOINTMENT_REQUEST_TODAY, TodayAppointments);
    yield takeEvery(APPOINTMENT_REQUEST_UPCOMING, UpComingAppointments);
    yield takeEvery(APPOINTMENT_REQUEST_PAST, PastAppointments);

}
